module.exports = __webpack_public_path__ + "media/features/audio-hero/images/phones_mobile-9a4a52a0bfba03115ec21b4fd1fa248c.png";